<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ titleText | translate }}</h4>
    </div>

    <div class="modal-body static-text-editor-toolbar-wrapper">
        <sp-common-editor
            [inline]="false"
            [content]="subscriptionMessage"
            [changeContentOnKeyUp]="false"
            (focusOutEvent)="blurHandler($event)"
            (isEmptyContent)="isEmptyContent($event)"
            [baseHref]="baseHref"
            [deviceMode]="deviceMode"
        >
        </sp-common-editor>

        <p *ngIf="isBlockConfirm" class="help-block mt-10 text-error">
            {{ "control_errors_required" | translate }}
        </p>
        <div *ngIf="isShopCart" class="small help-block mt-10">
            <span class="sp-icon icon-info mr-5"></span>
            <span [innerHTML]="'shop_cart_payment_success_deal_number_hint' | translate"></span>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-default mr-10" type="button" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary" [ngClass]="{ disabled: isBlockConfirm }" (click)="onConfirm()">
            {{ "apply" | translate }}
        </button>
    </div>
</div>
